module.exports = __webpack_public_path__ + "static/media/board.793b9230.png";